import { AddTransfersToPaymentDocument, PaymentsPageDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useAddTransfersMutation = () => {
  const today = moment().format('YYYY-MM-DD')
  const weekStart = moment().startOf('week').format('YYYY-MM-DD')
  const weekEnd = moment().endOf('week').format('YYYY-MM-DD')
  const { company } = useCurrentSession()
  const [addTransfersBankingPayment, { loading }] = useMutation(AddTransfersToPaymentDocument, {
    extractorFn: (data) => data.bankingMutations.addTransfersBankingPayment,
    refetchQueries: [
      {
        query: PaymentsPageDocument, // We need updated values in transfer insights
        variables: {
          companyId: company.id,
          featureNames: ['dev_finance_swan_reactivation'],
          todayDate: today,
          weekRange: { from: weekStart, to: weekEnd },
        },
      },
    ],
    awaitRefetchQueries: true,
  })

  const submitAddTransfers = async ({
    onSuccess,
    transferIds,
    paymentId,
  }: {
    onSuccess: () => void
    transferIds: number[]
    paymentId: number
  }) => {
    const result = await addTransfersBankingPayment({
      variables: {
        paymentId: paymentId,
        transferIds: transferIds,
      },
    })
    const handled = handleResult(result, () => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.bulk_payment.new_bulk_payment_modal.added_transfers'),
      })
      onSuccess()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
    return handled
  }

  return {
    submitAddTransfers,
    loading,
  }
}
